import { useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, testId = "image-upload", label = "Image" }) {
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {value ? (
        <div className="relative w-full h-40 rounded-md overflow-hidden border border-border group">
          <img src={fileUrl(value)} alt={label} className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange(null)} data-testid={`${testId}-remove`} className="absolute top-2 right-2 bg-black/70 text-white rounded-full p-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center w-full h-40 border border-dashed border-border rounded-md cursor-pointer hover:bg-secondary transition-colors" data-testid={testId}>
          {loading ? <Loader2 className="w-5 h-5 animate-spin text-accent" /> : <ImagePlus className="w-6 h-6 text-muted-foreground" strokeWidth={1.5} />}
          <span className="text-xs text-muted-foreground mt-2">{loading ? "Uploading…" : `Upload ${label.toLowerCase()}`}</span>
          <input type="file" accept="image/*" className="hidden" onChange={handle} />
        </label>
      )}
    </div>
  );
}
